import { render } from "./Nombre.vue?vue&type=template&id=c4033574&scoped=true"
import script from "./Nombre.vue?vue&type=script&lang=js"
export * from "./Nombre.vue?vue&type=script&lang=js"

import "./Nombre.vue?vue&type=style&index=0&id=c4033574&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4033574"]])

export default __exports__